import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const workable = defineConnector({
  identifier: "workable",
  name: "Workable",
  tagLine: "Recruiting and applicant tracking",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://[^/]*\\.workable\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your Workable API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Workable](https://www.workable.com/) and go to **Settings → Integrations → Access Token** to generate a new API token. Your subdomain is the part before `.workable.com` in your Workable URL.",
        },
      ],
    },
    {
      title: "Connect your Workable account",
      items: [
        {
          kind: "markdown",
          content: "Enter your Workable instance details and API credentials.",
        },
        {
          kind: "input",
          label: "Workable Domain",
          placeholder: "domain",
          required: true,
          target: { kind: "configuration", field: "subdomain" },
          helperText:
            "The subdomain of your Workable account (e.g. https://domain.workable.com)",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The API key for your Workable account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.subdomain}.workable.com/spi/v3/accounts`,
  },
  publicEnvVars: ({ subdomain }) => ({
    WORKABLE_URL: subdomain ? `https://${subdomain}.workable.com` : "",
  }),
});
